export default __webpack_public_path__ + "static/media/form.dad6e752.svg";